import TranslationsService from '@/services/translations.service';

export default class TranslateFilter {

    public static transform(key: string, replaceParts?: { [key: string]: string | number }): any {
        const translations = TranslationsService.getInstance();
        const text = translations.translation(key);
        return text ? TranslateFilter.textWithReplacedParts(text, replaceParts) : key;
    }

    private static textWithReplacedParts(text: string, replaceParts?: { [key: string]: string | number }): string {
        if (replaceParts) {
            Object.keys(replaceParts).map(key => {
                text = text.replace('{' + key + '}', String(replaceParts[key]));
            });
        }
        return text;
    }
}
